import type { RowData, Table } from '@luminovo/data-stack';
import type { ComponentType, ReactElement } from 'react';

import type { TableAppSlot } from '../tableAppSlot';
import { TableAppsMenu } from './TableAppsMenu';

/**
 * A table's `ActionButton`: the slot's Apps menu, then the table's own `Actions`, if any.
 *
 * Call it once, at module scope, so every render gets the same component. `getAppSlot` runs on every
 * render, so a slot that needs page ids, or that the page picks, reads them from the table's `sharedContext`.
 */
export function createActionButton<TSharedContext>(
    getAppSlot: (sharedContext: TSharedContext) => TableAppSlot,
    Actions?: ComponentType<{ sharedContext: TSharedContext }>,
) {
    return function ActionButtonWithAppsMenu<TData extends RowData>({
        table,
        sharedContext,
    }: {
        table: Table<TData>;
        sharedContext: TSharedContext;
    }): ReactElement {
        return (
            <>
                <TableAppsMenu table={table} appSlot={getAppSlot(sharedContext)} />
                {Actions && <Actions sharedContext={sharedContext} />}
            </>
        );
    };
}
